import { render, staticRenderFns } from "./ed-split-tabs.vue?vue&type=template&id=4cd60e46&scoped=true&"
import script from "./ed-split-tabs.ts?vue&type=script&lang=ts&"
export * from "./ed-split-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./ed-split-tabs.scss?vue&type=style&index=0&id=4cd60e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd60e46",
  null
  
)

export default component.exports